import React, { Component } from 'react';
import PropTypes from 'prop-types';
import mixpanel from 'mixpanel-browser';
import { getProductTrackingData, normalizeProductSelected } from '../../../helpers';
import TrackingEvents from '../../../common/models/TrackingEvents';
import ProductImageCard from '../../../components_common/ProductImageCard';
import { ImageWrapper } from './RelatedProducts.css';
import VerticalSpacer from '../../../components_common/VerticalSpacer/VerticalSpacer';
import ProductListProductInfo from '../../../components_common/ProductInfoCard/ProductListProductInfo';
import productInfoDataSanitizer from '../../../components_common/ProductInfoCard/productInfoDataSanitizer';

class RelatedProductLink extends Component {
  componentDidMount() {
    const { currencySymbol, product } = this.props;
    const trackingData = getProductTrackingData(product, currencySymbol, {});

    mixpanel.track_links(
      `#rp-${product.product_id}`,
      TrackingEvents.productSelected(),
      normalizeProductSelected(trackingData.product, trackingData.categoryDepartment)
    );
  }

  render() {
    const { product, s3BasePath, currencySymbol, showSale } = this.props;
    return (
      <a
        id={`rp-${product.product_id}`}
        href={product.url}
        data-cy="single-product-related"
        style={{ textDecoration: 'none' }}
      >
        <ImageWrapper>
          <ProductImageCard cart images={product.images} padTop="0" s3BasePath={s3BasePath} product={product} />
        </ImageWrapper>
        <VerticalSpacer height="14px" />
        <ProductListProductInfo
          currencySymbol={currencySymbol}
          product={productInfoDataSanitizer(product)}
          showSale={showSale}
          width="100%"
        />
      </a>
    );
  }
}

RelatedProductLink.propTypes = {
  currencySymbol: PropTypes.string.isRequired,
  product: PropTypes.array.isRequired,
  s3BasePath: PropTypes.string.isRequired,
  showSale: PropTypes.bool
};

export default RelatedProductLink;
